import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, fmtDate } from "@/components/ui-bits";
import { Megaphone } from "lucide-react";

export default function Announcements() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/announcements").then(({ data }) => setRows(data)); }, []);
  return (
    <div>
      <PageHeader title="Announcements" subtitle="Updates from the SpectralX team" />
      <div className="space-y-4 max-w-3xl" data-testid="announcements-list">
        {rows.map((a) => (
          <div key={a.id} className="glass p-5">
            <div className="flex items-start gap-3">
              <Megaphone className="text-[#00F0FF] mt-1" size={20} />
              <div className="flex-1">
                <div className="font-display text-lg font-bold">{a.title}</div>
                <div className="text-xs text-[#94A3B8] mt-1 uppercase tracking-wider">{fmtDate(a.created_at)}</div>
                <div className="text-sm mt-3 text-[#94A3B8] leading-relaxed whitespace-pre-line">{a.description}</div>
              </div>
            </div>
          </div>
        ))}
        {rows.length === 0 && <div className="text-[#475569] text-sm py-6 text-center">No announcements yet</div>}
      </div>
    </div>
  );
}
